/* eslint-disable */
export const user = {
    id    : '01b01572-55b0-4638-8a67-aa60b2244a1e',
    name  : 'Dang Miracle',
    email : 'dangmiracle@gmail.com',
    avatar: 'assets/images/avatars/brian-hughes.jpg',
    status: 'online',
};
